/**
 * Inline Search Component
 * Controls toggle visibility - predictive search handles search functionality
 * @extends HTMLElement
 */
class InlineSearchWrapper extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLElement|null} */
    this.toggleButton = this.querySelector("[data-inline-search-toggle]");

    /** @type {HTMLElement|null} */
    this.closeButton = this.querySelector("[data-inline-search-close]");

    /** @type {HTMLInputElement|null} */
    this.searchInput = /** @type {HTMLInputElement|null} */ (this.querySelector("#inline-search-input"));

    // Bind methods
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  connectedCallback() {
    if (!this.toggleButton) return;

    this.toggleButton.addEventListener("click", this._prevent(this.open));

    if (this.closeButton) {
      this.closeButton.addEventListener("click", this._prevent(this.close));
    }

    // Handle escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.classList.contains("is-active")) {
        this.close();
      }
    });

    // Close on outside click
    document.addEventListener("click", (e) => {
      if (this.classList.contains("is-active") && !this.contains(/** @type {Node} */ (e.target))) {
        this.close();
      }
    });

    this.addEventListener("click", (e) => e.stopPropagation());
  }

  /**
   * Prevent default + stop propagation wrapper
   * @param {Function} handler
   * @returns {(e: Event) => void}
   */
  _prevent(handler) {
    return (e) => {
      e.preventDefault();
      e.stopPropagation();
      handler();
    };
  }

  open() {
    this.classList.add("is-active");

    // Focus the search input after animation starts
    setTimeout(() => this.searchInput?.focus(), 100);
  }

  close() {
    this.classList.remove("is-active");

    // Clear the search input
    if (this.searchInput) {
      this.searchInput.value = "";
      // Trigger input event to clear results
      this.searchInput.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }
}

customElements.define("inline-search-wrapper", InlineSearchWrapper);
